<h2 mat-dialog-title>
    @if (data.user.type === 'guest') {
        Edit Guest
    } @else {
        Edit User
    }
</h2>
<mat-dialog-content>
    <div style="display: flex; flex-direction: column; gap: 20px;">
        
        <!-- User Type & Basic Info -->
         @if (data.user.type == 'user') {
            <mat-card>
                <mat-card-header>
                    <mat-card-title>Basic Information</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div style="display: flex; flex-direction: column; gap: 10px;">
                        <span><strong>Username:</strong> {{ data.user.username }}</span>
                        <span><strong>ID:</strong> {{ data.user.id }}</span>
                    </div>
                </mat-card-content>
            </mat-card>
        }

        <!-- Discord Info (Users only) -->
        @if (data.user.type === 'user' && data.user.connections.discord) {
            <mat-card>
                <mat-card-header>
                    <mat-card-title>Discord Information</mat-card-title>
                    @if (data.user.connections.discord.avatar) {
                        <app-avatar mat-card-avatar [src]="data.user.connections.discord.avatar" [alt]="data.user.connections.discord.username" style="width: 40px; height: 40px;"></app-avatar>
                    }
                </mat-card-header>
                <mat-card-content>
                    <div style="display: flex; flex-direction: column; gap: 10px;">
                        <span><strong>Discord ID:</strong> {{ data.user.connections.discord.id }}</span>
                        <span><strong>Discord Username:</strong> {{ data.user.connections.discord.username }}</span>
                    </div>
                </mat-card-content>
            </mat-card>
        }

        <!-- VRChat Info -->
        <mat-card>
            <mat-card-header>
                <mat-card-title>VRChat Information</mat-card-title>
                @if (data.user.connections.vrchat?.avatar) {
                    <app-avatar mat-card-avatar [src]="data.user.connections.vrchat?.avatar" [alt]="data.user.connections.vrchat?.username || 'VRChat Avatar'" style="width: 40px; height: 40px;"></app-avatar>
                }
            </mat-card-header>
            <mat-card-content>
                @if (data.user.connections.vrchat) {
                    <div style="display: flex; flex-direction: column; gap: 10px;">
                        <span><strong>VRChat ID:</strong> {{ data.user.connections.vrchat.id }}</span>
                        <span><strong>VRChat Username:</strong> {{ data.user.connections.vrchat.username }}</span>
                    </div>
                } @else {
                    <span>No VRChat connection</span>
                }
                <button mat-button (click)="openVRChatAccount()">Edit VRChat</button>
            </mat-card-content>
        </mat-card>

        <!-- Patreon Info -->
        <mat-card>
            <mat-card-header>
                <mat-card-title>Patreon Information</mat-card-title>
                @if (data.user.connections.patreon?.avatar) {
                    <app-avatar mat-card-avatar [src]="data.user.connections.patreon?.avatar" [alt]="data.user.connections.patreon?.username || 'Patreon Avatar'" style="width: 40px; height: 40px;"></app-avatar>
                }
            </mat-card-header>
            <mat-card-content>
                @if (data.user.connections.patreon) {
                    <div style="display: flex; flex-direction: column; gap: 10px;">
                        <span><strong>Patreon ID:</strong> {{ data.user.connections.patreon.id }}</span>
                        <span><strong>Patreon Username:</strong> {{ data.user.connections.patreon.username }}</span>
                        <span><strong>Subscription Tier:</strong> <span [style.color]="data.user.connections.patreon.subscriptionTier?.color ?? '#888888'">{{ data.user.connections.patreon.subscriptionTier?.name ?? "???" }}</span></span>
                        @if (data.user.connections.patreon.email) {
                            <span><strong>Email:</strong> {{ data.user.connections.patreon.email }}</span>
                        }
                        @if (data.user.connections.patreon.expire) {
                            <span><strong>Expires:</strong> {{ data.user.connections.patreon.expire }}</span>
                        }
                        @if (data.user.connections.patreon.connected_at) {
                            <span><strong>Connected:</strong> {{ data.user.connections.patreon.connected_at }}</span>
                        }
                    </div>
                } @else {
                    <span>No Patreon connection</span>
                }
                <button mat-button (click)="openPatreonAccount()">Edit Patreon</button>
            </mat-card-content>
        </mat-card>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>

